import React, { useState } from "react";
import { Button,  InfoText,  Modal, StatusTags  } from "../../../../../../components";
import { formatWords2 } from "../../../../../../utils/stringUtils";
import { keyToTitle } from "../../../../../../utils";
// import { keyToTitle } from "../../../../../../utils";

const Info = ({ jobDetails }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const jobInfo = jobDetails?.jobInfo || {};
  const orgInform = jobDetails?.orgInform || {};
  const location = jobInfo?.location || {};
  const skills = jobDetails?.skills || {};

  const JobStatus = {
    // 1: "Draft",
    2: "Active",
    3: "On Hold",
    4: "Hold by Client",
    5: "Interview L1",
    6: "Interview L2",
    7: "Interview L3",
    8: "Priority",
    9: "Filled",
    10: "Closed",
    11: "Agreement Sent",
    12: "Agreement Accepted",
  };

  const Priority = {
    1: "Critical",
    2: "High",
    3: "Medium",
    4: "Low"
  }

  const JobTypes = {
    1: "Full Time",
    2: "Contract",
    3: "Part Time",
  }
  const EmployeementType = {
    1: "1099",
    2: "C2C",
    3: "C2C",
    4: "Full Time",
    5: "In-cop",
    6: "Intern",
    7: "Other",
    8: "Part Time",
    9: "W-2"
  }
  const currencyMap = {
    1: "USD",
    2: "INR",
    3: "CAD"
  };

  const latestStatus =
    jobDetails?.statusHistory?.length
      ? jobDetails.statusHistory[jobDetails.statusHistory.length - 1].status
      : 2;

  let jobDescriptionDetails = [
    {
      "Job Code": jobInfo?.jobCode || "N/A",
      // Status: JobStatus[jobDetails?.jobId?.status] || "N/A",
      Status: latestStatus !== null
        ? JobStatus[latestStatus]
        : "N/A",
      Country: formatWords2(jobDetails?.jobId?.location?.country || "N/A"),
      // "No. of positions": jobInfo?.reqHourWeek || "N/A",
      "No. of positions": orgInform?.noOfPosition || "N/A",
      "Job Title": formatWords2(jobDetails?.jobId?.title || "N/A"),
      // Location: `${location?.city || "N/A"}, ${location?.state || "N/A"}`,
      Location: `${[formatWords2(location?.city), formatWords2(location?.state)].filter(Boolean).join(", ") || "N/A"}`,
      //displaying jobpost priority
      priority: Priority[jobInfo?.priority] || "N/A",
      "Work Experience": skills?.experience
        ? `${skills.experience?.min} - ${skills.experience?.max} yrs`
        : "N/A",
    },
  ];
  let recruitmentTeamDetails = [
    // not integrated this part
    {
      Recruiter: "fdahgf-163475123",
      "Additional Recruiters": "India",
      "Recruitement Manager": "--",
      "Source(RA Name)": "India",
      "Account Manager": "India",
    },
  ];
  let paymentDetails = [
    {
      "Job Type": JobTypes[jobInfo?.type] || "N/A",
      "Pay Type": EmployeementType[jobInfo?.payments?.billRate?.employmentType] || "N/A",
      // "Pay Rate": jobInfo?.payments?.payRate?.amount
      // ? `${jobInfo.payments.payRate.amount?.min} - ${jobInfo.payments.payRate.amount?.max} ${currencyMap[jobInfo.payments.payRate?.currency]}`
      // : "N/A",
      "Pay Rate": jobInfo?.payments?.payRate?.amount &&
        [jobInfo.payments.payRate.amount.min,
        jobInfo.payments.payRate.amount.max,
        currencyMap[jobInfo.payments.payRate?.currency]]
          .filter(Boolean)
          .join(" - ") || "N/A"
    },
  ];

  const cleanHtml = (html = "") => {
    return html
      // remove scripts
      .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
      // remove styles
      .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "")
      // remove Word comments
      .replace(/<!--[\s\S]*?-->/g, "")
      // remove XML / Office tags
      .replace(/<\/?(o|w|m):[^>]*>/gi, "")
      // remove meta & link tags
      .replace(/<(meta|link)[^>]*>/gi, "")
      // remove inline styles & classes
      .replace(/\s?(style|class|id)="[^"]*"/gi, "")
      // // normalize line breaks
      // .replace(/\n+/g, "<br />");
  };

  return (
    <div>
      <div className="flex gap-2 items-center">
        <h6 className="my-2">Job Description</h6>
        <Button
          type="icon"
          color="black"
          variant="text"
          icon={"info"}
          onClick={() => setIsModalOpen(true)}
        />
      </div>
      <p className="text-sm text-gray-400 font-[400]"
        dangerouslySetInnerHTML={{ __html: cleanHtml(jobDetails?.orgInform?.jobDescription) }}
      >
      </p>
      <div className="my-2 grid  lg:grid-cols-2 xl:grid-cols-4 gap-5 py-4 rounded">
        {Object.entries(jobDescriptionDetails[0]).map(([key, value]) => {
          const displayValue =
            key === "Status" ? (
              <StatusTags tag={value} variant="text" className={"!px-0"} />
            ) : (
              value
            );
          return (
            <InfoText
              size="sm"
              key={key}
              title={keyToTitle(key)}
              value={displayValue}
            />
          );
        })}
      </div>
      <h6>Recruitement Team</h6>
      <div className="my-2 grid grid-cols-4 gap-5 py-4 rounded">
        {Object.entries(recruitmentTeamDetails[0]).map(([key, value]) => {
          return (
            <InfoText
              size="sm"
              key={key}
              title={keyToTitle(key)}
              value={value}
            />
          );
        })}
      </div>
      <h6>Pay & Billing Details</h6>
      <div className="my-2 grid grid-cols-5 gap-5 py-4 rounded">
        {Object.entries(paymentDetails[0]).map(([key, value]) => {
          return (
            <InfoText
              size="sm"
              key={key}
              title={keyToTitle(key)}
              value={value}
            />
          );
        })}
      </div>

      <Modal
        isOpen={isModalOpen}
        title={"Job Description"}
        onClose={() => setIsModalOpen(false)}
        width="max-w-3xl"
      >
        <div
          className="h-100"
          dangerouslySetInnerHTML={{
            __html: cleanHtml(
              jobDetails?.orgInform?.jobDescription || ""
            )
          }}
        >
        </div>
      </Modal>
    </div>
  );
};

export default Info;
